/** campaign-companies RENDERER — overview page + COMPANIES directory.
 *  Wraps the shared campaign renderer with the companies column set. */
import { renderCampaignReport } from '../campaign-overview/render';
import type { CampaignReport } from '../../schema/campaign';

export function renderCampaignCompaniesReport(d: CampaignReport, o: Parameters<typeof renderCampaignReport>[1] = {}): string {
  return renderCampaignReport(d, { ...o, companiesDirectory: true });
}
